import { getLocaleFromHtmlLang, useAutoLanguageChange } from './utils/language';

export interface MainConfig {
  locale?: string;
  hooks?: HooksConfig;
}

export interface HooksConfig {
  onAddToCart?: (params: { productId: string; quantity: number; currency: string; name: string }) => void;
  onInitiateCheckout?: (params: { transactionTotal: number; transactionId: string }) => void;
  onCheckoutSuccess?: (params: { price: number; ecommerceData: object; fbqData: object; eventID: string }) => void;
  enableMetaTracking?: boolean;
  enableGtagTracking?: boolean;
  enableGtagUserDataTracking?: boolean;
  gtagAdsSendTo?: string;
  metaPixelId?: string;
  enableDataLayer?: boolean;
}

export function getRTRLocale(): string {
  return (window as any).RTR_LOCALE || (window as any).RENTWARE_LANGUAGE;
}

export function getMainConfig(): MainConfig {
  let locale = getRTRLocale();

  if (useAutoLanguageChange()) {
    locale = getLocaleFromHtmlLang();
  }

  return {
    locale,
    hooks: (window as any).RTR_HOOKS || (window as any).RENTWARE_HOOKS,
  };
}

export interface ApiConfig {
  apiBaseUrl: string;
  accessToken: string;
  basicAuthUser: string;
  basicAuthPass: string;
}

export function getApiConfig(): ApiConfig {
  return {
    apiBaseUrl: getApiBaseUrl(),
    accessToken: getAccessToken(),
    basicAuthUser: (window as any).RTR_API_BASIC_AUTH_USER || (window as any).RENTWARE_API_BASIC_AUTH_USER,
    basicAuthPass: (window as any).RTR_API_BASIC_AUTH_PASS || (window as any).RENTWARE_API_BASIC_AUTH_PASS,
  };
}

function getApiBaseUrl(): string {
  const apiUrlOverwritten = (window as any).RTR_API_URL_OVERWRITTEN;
  if (apiUrlOverwritten) {
    return apiUrlOverwritten + '/api/v1';
  }

  return 'https://widget.rtr-io.com';
}

function getAccessToken(): string {
  const accessToken = (window as any).RTR_ACCESS_TOKEN;
  if (accessToken) {
    return accessToken;
  }

  const legacyHostOverwritten = (window as any).RENTWARE_API_HOST_OVERWRITTEN;
  if (legacyHostOverwritten) {
    return legacyHostOverwritten;
  }

  const legacyBaseUrl = (window as any).RENTWARE_BASE_API_URL;
  if (legacyBaseUrl) {
    try {
      const url = new URL(legacyBaseUrl);
      return url.host;
    } catch (e) {
      console.error(e);
    }
  }

  return null;
}
